// ADD HERE NAME OF OLD VERSION OF THE SOP TO PREVENT FOR SIGNING OFF  THE OLD FORM.
// it will automatically disable this function in the UI

export default {
  line1: [],
  line24: [],
  line3: [],
  shop1: []
};
